import { useRef } from 'react';
import ButtonText from '../../components/button/button-text/ButtonText';
import Image from '../../components/image/Image';
import GiveawayModalForm from './GiveawayModalForm';
import { useProject } from '../project-hooks/useProject';
import styles from './giveaway-banner.module.less';
import { Heading5 } from '@sb1/ffe-core-react';

const GiveawayBanner = () => {
    const project = useProject();

    const { introText, logoUrl, logoAlt } = project.profile.giveaway;
    const modalRef = useRef();

    const openModal = () => {
        modalRef?.current?.open();
    };

    return (
        <div className={styles.banner}>
            {!!logoUrl && (
                <div className={styles.logoContainer} onClick={openModal}>
                    <Image src={logoUrl} alt={logoAlt} className={styles.logo} />
                </div>
            )}
            <div className={styles.infoContainer} onClick={openModal}>
                <Heading5 noMargin className={styles.header}>
                    Bli med i trekningen!
                </Heading5>
                <div className={styles.introText}>{introText}</div>
                <ButtonText className={styles.bannerButton} onClick={openModal}>
                    Meld deg på
                </ButtonText>
            </div>

            <GiveawayModalForm modalRef={modalRef} />
        </div>
    );
};

export default GiveawayBanner;
